import React from "react"
import "./index.less"
import ResultEmptyState from "./emptyStates/resultEmptyState"
import EvolutionEmptyState from "./emptyStates/evolutionEmptyState"

import arrow from "images/blue-right-arrow.svg"

import { Popover, Progress } from "antd"
import { get, round } from "lodash"
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
import { SURVEY_CALCULATION_TYPE } from "../../utils/constants"
import { loadTexts } from "../../utils/i18n"

function formatDate(inputDate) {
  var date = new Date(inputDate)
  if (!isNaN(date.getTime())) {
    var day = date.getDate().toString()
    var month = (date.getMonth() + 1).toString()
    // Months use 0 index.

    return `${day[1] ? day : `0${day[0]}`}/${
      month[1] ? month : `0${month[0]}`
    }/${date.getFullYear()}`
  }
}

const ReportCard = (props) => {
  const intl = loadTexts("reports_dashboard")
  const isTopTwoBox =
    props.data.calculation_type == SURVEY_CALCULATION_TYPE.topTwoBox

  const valueProgressChart = isTopTwoBox
    ? `${parseInt(get(props.data, "result_display", "n/a"))}%`
    : get(props.data, "result_display", "n/a")

  const valueLineChart = (value) => {
    return isTopTwoBox ? `${parseInt(value)}%` : value
  }

  return (
    <div className="report-card">
      <div className="report-card-header">
        <div
          className="report-card-header-title"
          onClick={() =>
            props.onEnterIndicatorReport(
              props.data.id_survey_type,
              props.data.id_measure
            )
          }>
          {props.data.name}{" "}
          {props.data.id_survey_type === 1 && (
            <span
              style={{
                marginLeft: "8px",
                padding: "4px 8px",
                borderRadius: "3px",
                background: "rgba(44, 91, 255, 0.1)",
                color: "#2C5BFF",
                fontWeight: "600",
              }}>
              Engagement
            </span>
          )}
        </div>
        <img
          onClick={() =>
            props.onEnterIndicatorReport(
              props.data.id_survey_type,
              props.data.id_measure
            )
          }
          src={arrow}
          alt="arrow"
          className="report-card-header-arrow"
        />
      </div>
      <div className="report-card-body">
        <div className="report-card-body-item-start">
          <div className="report-card-body-title">
            {intl.dashboard.reportCard.result}
            <span className="report-card-body-title-description">
              {intl.dashboard.reportCard.lastMeasure}
            </span>
          </div>
          {props.data.result ? (
            <>
              <Popover
                content={`${intl.dashboard.reportCard.popover} ${get(
                  props.data,
                  "name_measure",
                  "n/a"
                )}`}
                arrowPointAtCenter>
                <Progress
                  style={{ marginTop: "12px", width: "74px" }}
                  width={74}
                  format={(percent) => (
                    <div
                      style={{
                        fontWeight: 600,
                        color: get(props.data, "color", "black"),
                      }}>
                      {valueProgressChart}
                    </div>
                  )}
                  strokeWidth={9}
                  strokeColor={get(props.data, "color", "black")}
                  type="circle"
                  percent={
                    isTopTwoBox
                      ? parseInt(get(props.data, "result", "n/a"))
                      : round((get(props.data, "result", "n/a") / 5) * 100)
                  }
                />
              </Popover>
            </>
          ) : (
            <ResultEmptyState />
          )}
        </div>
        <div className="report-card-body-item-end">
          <div className="report-card-body-title">
            {intl.dashboard.reportCard.evolution}
          </div>
          {props.data.evolution ? (
            <>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  width={300}
                  height={100}
                  data={props.data.evolution}
                  margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
                  <Line
                    dot={{ stroke: "#3482D7" }}
                    activeDot={{ r: 3, stroke: "#3482D7" }}
                    type="linear"
                    dataKey="value"
                    stroke="#3482D7"
                    strokeWidth={2}
                    label={(props) => {
                      const { x, y, value } = props
                      return (
                        <text
                          x={x}
                          y={y}
                          dy={15}
                          fill="#3482D7"
                          fontSize={10}
                          textAnchor="middle">
                          {valueLineChart(value)}
                        </text>
                      )
                    }}
                  />
                  <Tooltip
                    content={({ active, payload, label }) => {
                      if (active && payload && payload.length) {
                        return (
                          <div className="report-card-evolution-tooltip">
                            <div className="report-card-evolution-tooltip-title">{`${payload[0].payload.name}`}</div>
                            <div className="report-card-evolution-tooltip-description">
                              {intl.dashboard.reportCard.tooltip +
                                payload[0].payload.date_start}
                            </div>
                          </div>
                        )
                      }
                      return null
                    }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </>
          ) : (
            <EvolutionEmptyState />
          )}
        </div>
      </div>
    </div>
  )
}

export default ReportCard
